import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { NotificationListComponent } from './notification-list.component';

@NgModule({
  declarations: [NotificationListComponent],
  imports: [CommonModule, TranslateModule],
  exports: [NotificationListComponent],
})
export class NotificationListModule {}
